/**
 * Created by andrey on 10.02.2021.
 */

const Quests = function (slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.quests = [];
    this.lastFinished = 0;

    this.completed = 0;
    this.claimedThresholds = new Set();

    Quests.InitConfig(cleverapps.meta.getSelectedLocation());

    this.config = QuestsConfig[Map2dLocation.currentLocation.location.locationId];

    if (!this.config) {
        Object.assign(this, Quests.FakeQuests);
        return;
    }

    cleverapps.eventBus.on("unitOpened", this.onUnitOpened.bind(this), this);
    cleverapps.eventBus.on("mapEvent", this.onMapEvent.bind(this), this);

    this.load();

    this.isAllDone = this.calcIsAllDone();
};

Quests.prototype = Object.create(cleverapps.EventEmitter.prototype);
Quests.prototype.constructor = Quests;

Quests.prototype.load = function () {
    if (cleverapps.gameModes.skipQuests) {
        return;
    }

    const stored = this.slot.load("quests") || {};

    const added = {};
    this.quests = (stored.quests || []).filter(function (data) {
        if (added[data.id]) {
            return false;
        }
        const questConfig = this.config[data.id];
        if (!questConfig) {
            return false;
        }
        if (questConfig.dynamic) {
            if (questConfig.dynamic.filter && !questConfig.dynamic.filter({ unit: data.unit })) {
                return false;
            }
            if (questConfig.dynamic.getUnit && data.unit === undefined) {
                return false;
            }
        }
        if (!Quests.tryFixUnitStage(data.unit)) {
            return false;
        }
        added[data.id] = true;
        return true;
    }, this).map((data) => {
        const quest = new Quest(data);
        quest.replayTutorial();
        return quest;
    });

    this.completed = (stored.completed !== undefined ? stored.completed : this.calcCompletedQuestsCount()) || 0;
    this.claimedThresholds = new Set(cleverapps.fromBit(stored.thresholds));
};

Quests.prototype.save = function () {
    this.slot.save("quests", this.getInfo());
};

Quests.prototype.getInfo = function () {
    const quests = this.quests.map((quest) => quest.save());

    return {
        quests,
        completed: this.completed || undefined,
        thresholds: cleverapps.toBit(this.claimedThresholds) || undefined
    };
};

Quests.prototype.getCompletedQuestsCount = function () {
    return this.completed;
};

Quests.prototype.getFinishedQuestsCount = function () {
    const currentlyFinished = this.quests.filter((quest) => quest.isFinished()).length;
    return this.completed + currentlyFinished;
};

Quests.prototype.isThresholdClaimed = function (index) {
    return this.claimedThresholds.has(index);
};

Quests.prototype.addClaimedThreshold = function (index) {
    this.claimedThresholds.add(index);
    this.save();
    cleverapps.sideBar.resetByClassName(QuestsIcon);
};

Quests.prototype.hasAttention = function () {
    const questsBarConfig = cleverapps.meta.getSelectedLocation().locationConfig.questsBar;
    if (questsBarConfig) {
        const percentage = Math.round(this.getFinishedQuestsCount() / questsBarConfig.totalQuests * 100);
        return questsBarConfig.thresholds.some((threshold, i) => percentage >= threshold && !this.isThresholdClaimed(i));
    }
    return false;
};

Quests.prototype.claimFinishedQuest = function (quest) {
    delete quest.pendingClaim;
    const index = this.quests.indexOf(quest);
    if (index !== -1) {
        this.quests.splice(index, 1);
    }
    this.completed++;
    this.trigger("questProgressUpdated");
    cleverapps.eventBus.trigger("questFinished", quest);
    this.trigger("questRemoved", quest);
    this.save();
    cleverapps.sideBar.resetByClassName(QuestsIcon);
    this.create({ quest: quest.id });
    if (this.quests.length === 0) {
        this.isAllDone = this.calcIsAllDone();
    }
};

Quests.prototype.removeFinishedQuest = function (quest) {
    quest.rewards.receiveRewards();
    this.claimFinishedQuest(quest);
};

Quests.prototype.calcIsAllDone = function () {
    const activeIds = new Set(this.quests.map((q) => q.id));
    return Object.values(this.config).filter((config) => config.trigger).every((config) => {
        if (activeIds.has(config.quest.id)) {
            return false;
        }
        if (config.trigger.unit) {
            return cleverapps.unitsLibrary.isOpened(config.trigger.unit);
        }
        if (config.trigger.family) {
            return cleverapps.unitsLibrary.hasOpened(config.trigger.family.code);
        }
        if (config.trigger.fog) {
            return Map2d.currentMap.fogs.isOpened(config.trigger.fog);
        }
        return false;
    });
};

Quests.prototype.calcCompletedQuestsCount = function () {
    if (!cleverapps.meta.getSelectedLocation().locationConfig.questsBar) {
        return 0;
    }

    const activeIds = new Set(this.quests.map((q) => q.id));

    return Object.keys(this.config).filter((id) => {
        const config = this.config[id];
        if (activeIds.has(id)) {
            return false;
        }
        if (config.trigger && config.trigger.unit) {
            return cleverapps.unitsLibrary.isOpened(config.trigger.unit);
        }
        if (config.trigger && config.trigger.fog) {
            return Map2d.currentMap.fogs.isOpened(config.trigger.fog);
        }
        return false;
    }).length;
};

Quests.prototype.finishHeroChestQuests = function () {
    this.quests.forEach((quest) => {
        if (quest.id === "r_open_herochest" && quest.progress > 0 && !cleverapps.unitsLibrary.getCurrentHero()) {
            quest.progress = quest.goal;
        }
    }, this);
};

Quests.prototype.finishQuestsByUnit = function (unit, type) {
    const isLast = unit.isLast();
    this.quests.forEach((quest) => {
        if (quest.unit && quest.unit.code === unit.code && (isLast || quest.unit.stage === unit.stage) && quest.type === type) {
            quest.progress = quest.goal;
        }
    });
};

Quests.prototype.isRunning = function (id) {
    return this.quests.some((quest) => id === quest.id);
};

Quests.prototype.isEmpty = function () {
    return this.quests.length === 0;
};

Quests.prototype.count = function () {
    return this.quests.length;
};

Quests.prototype.create = function (trigger) {
    if (cleverapps.gameModes.skipQuests) {
        return;
    }

    const chosenData = [];

    Object.values(this.config).forEach((config) => {
        if (!config.trigger || this.isRunning(config.quest.id)) {
            return;
        }

        if (config.dynamic && config.dynamic.filter && !config.dynamic.filter({ create: true, unit: trigger.unit })) {
            return;
        }

        if (config.dynamic && config.dynamic.getGoal && !config.dynamic.getGoal(config.quest)) {
            return;
        }

        if (config.trigger.recipesCodes && trigger.recipe && config.trigger.recipesCodes.some((recipeCode) => recipeCode === trigger.recipe.code)) {
            const clone = cleverapps.clone(config, true);
            clone.quest.recipeCode = trigger.recipe.code;
            clone.quest.unit = { code: trigger.unit.code, stage: trigger.unit.stage };
            chosenData.push(clone);
            return;
        }

        if (config.trigger.family && !trigger.recipe && Unit.SameLine(trigger.unit, config.trigger.family)) {
            chosenData.push(config);
            return;
        }

        if (config.trigger.unit && !trigger.recipe && Unit.Equals(trigger.unit, config.trigger.unit)) {
            chosenData.push(config);
            return;
        }

        if (config.trigger.fog && config.trigger.fog === trigger.fog) {
            chosenData.push(config);
            return;
        }

        if (config.trigger.quest && config.trigger.quest === trigger.quest) {
            chosenData.push(config);
        }
    });

    this.startQuests(chosenData);
};

Quests.prototype.startQuests = function (configs) {
    if (configs.length > 0) {
        configs.forEach((config) => {
            const quest = new Quest(config.quest, true);
            quest.setFresh(true);
            this.quests.push(quest);

            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.QUEST_START}${cleverapps.meta.selectedLocationId()}_${quest.id}`);
        });

        this.isAllDone = false;
        this.save();
        Map2dLocation.currentLocation.counter.trigger(100);
    }
};

Quests.prototype.onUnitOpened = function (unit) {
    this.onMapEvent(Map2d.OPEN_UNIT, { unit });
    this.create({ unit });
};

Quests.prototype.applyDynamicFilter = function () {
    const toRemove = [];
    this.quests.forEach(function (quest, index) {
        const config = this.config[quest.id];
        if (config && config.dynamic && config.dynamic.filter && !config.dynamic.filter()) {
            toRemove.push(index);
        }
    }, this);

    if (toRemove.length > 0) {
        for (let i = toRemove.length - 1; i >= 0; i--) {
            const quest = this.quests[toRemove[i]];
            this.quests.splice(toRemove[i], 1);
            this.trigger("questRemoved", quest);
        }
        this.save();
    }
};

Quests.prototype.showProgress = function () {
    if (cleverapps.focusManager.isFocused()) {
        return;
    }

    const quest = this.quests.find((quest) => quest.wantsToShowProgress());
    if (!quest) {
        return;
    }

    Map2dLocation.currentLocation.counter.setTimeout(() => {

    }, 1000);

    this.trigger("questProgressChanged", quest);
    cleverapps.eventBus.trigger("questProgressChanged", quest);

    quest.setProgressShown();
};

Quests.prototype.finish = function () {
    if (cleverapps.focusManager.isFocused()) {
        return;
    }

    let index;
    let quest;
    for (index = 0; index < this.quests.length; index++) {
        quest = this.quests[index];

        if (quest.dynamicFinished()) {
            quest.progress = quest.goal;
        }

        if (quest.isFinished() && !quest.pendingClaim) {
            break;
        }
    }

    if (index === this.quests.length) {
        return;
    }

    cleverapps.eventBus.trigger("taskEvent", "FINISH_QUEST");
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.QUEST_FINISH}${cleverapps.meta.selectedLocationId()}_${quest.id}`);
    Map2dLocation.LogDay(cleverapps.meta.selectedLocationId(), cleverapps.EVENTS.LOCATION.DAY_QUEST);

    if (!quest.rewards.listRewards().length) {
        cleverapps.throwAsync(`FinishQuest ${quest.id} empty prize`);
    }

    this.lastFinished = Date.now();

    const actions = [
        function (f) {
            quest.rewards.receiveRewards();

            if (!QuestsWindow.IsAvailable()) {
                this.quests.splice(index, 1);
                cleverapps.eventBus.trigger("questFinished", quest);
                this.save();
                this.create({ quest: quest.id });
            }

            f();
        }.bind(this),

        function (f) {
            if (QuestsWindow.IsAvailable()) {
                const claim = () => {
                    quest.rewards.updateViewAmount();
                    this.claimFinishedQuest(quest);
                    f();
                };

                const questsIcon = cleverapps.sideBar.findIconByClassName(QuestsIcon);
                if (questsIcon && questsIcon.available) {
                    questsIcon.showInfo(quest, { callback: claim });
                } else {
                    claim();
                }
            } else {
                this.showFinishInfo(quest, f);
            }
        }.bind(this),

        function (f) {
            quest.showTutorial(f, true);
        },

        function (f) {
            if (typeof CharacterUnlockedWindow !== "undefined" && CharacterUnlockedWindow.IsNeeded(quest)) {
                Map2dLocation.currentLocation.unitStories.displayFreshStory(quest.unit, f);
            } else {
                f();
            }
        },

        function (f) {
            if (typeof CharacterUnlockedWindow !== "undefined" && CharacterUnlockedWindow.IsNeeded(quest)) {
                new CharacterUnlockedWindow(quest);
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        },

        function (f) {
            quest.rewards.updateViewAmount();
            f();
        }
    ];

    if (quest.getTutorial(true) || typeof CharacterUnlockedWindow !== "undefined" && CharacterUnlockedWindow.IsNeeded(quest)) {
        cleverapps.focusManager.display({
            focus: "FinishQuest",
            actions
        });
        return;
    }

    Map2dLocation.currentLocation.counter.playActions(actions);
};

Quests.prototype.showFinishInfo = function (quest, callback) {
    cleverapps.focusManager.showControlsWhileFocused("QuestsGroupIcon");
    const questsGroupIcon = cleverapps.sideBar.findIconByClassName(QuestsGroupIcon);
    const questIcon = questsGroupIcon && questsGroupIcon.available ? questsGroupIcon.onGetIconViewListener(quest) : undefined;

    Map2dLocation.currentLocation.counter.playActions([
        function (f) {
            if (questIcon) {
                questsGroupIcon.onGetView().scrollToItem(questIcon, f);
            } else {
                f();
            }
        },

        function (f) {
            if (questIcon) {
                questIcon.updateProgressText();
            }

            Map2dLocation.currentLocation.counter.setTimeout(f, 250);
        },

        function (f) {
            if (typeof CharacterUnlockedWindow !== "undefined" && CharacterUnlockedWindow.IsNeeded(quest)) {
                f();
                return;
            }

            if (questIcon) {
                if (questsGroupIcon.canShowInfoView) {
                    questsGroupIcon.showInfo(quest, { iconView: questIcon, callback: f });
                    return;
                }
            } else {
                const questsIcon = cleverapps.sideBar.findIconByClassName(QuestsIcon);
                if (questsIcon && questsIcon.available) {
                    questsIcon.showInfo(quest, { callback: f });
                    return;
                }
            }

            f();
        },

        function (f) {
            this.trigger("questRemoved", quest);
            f();
        }.bind(this),

        function (f) {
            Map2dLocation.currentLocation.counter.setTimeout(() => {}, 800); // block counter until icon deletion animation is finished
            Map2dLocation.currentLocation.counter.setTimeout(f, 300);
        },

        function (f) {
            if (cleverapps.focusManager.focus === "FinishQuest") {
                cleverapps.focusManager.hideControlsWhileFocused("QuestsGroupIcon");
            }
            f();

            callback();
        }
    ]);
};

Quests.prototype.getFreshQuestsBatch = function () {
    let quests = this.quests.filter((quest) => quest.isFresh());

    const storyQuests = quests.filter((quest) => quest.getTutorial() || quest.getDialogue());

    quests = cleverapps.substract(quests, storyQuests, Quest.GetId);

    quests = storyQuests.slice(0, 1).concat(quests);

    return quests.slice(0, 2);
};

Quests.prototype.processFresh = function () {
    if (cleverapps.focusManager.isFocused() || cleverapps.gameModes.skipQuests) {
        return;
    }

    const quests = this.getFreshQuestsBatch();
    const quest = quests[0];

    if (quests.length === 0) {
        return;
    }

    const findOnStart = quests.some((q) => q.findOnStart);

    let units = [];

    if (quest.triggerUnit) {
        const center = Map2d.currentMap.getScreenCenterCell();
        units = Map2d.currentMap.listAvailableUnits(quest.triggerUnit).filter((unit) => unit.isBuilt()).sort((a, b) => cc.getDistanceChebyshev(a, center) - cc.getDistanceChebyshev(b, center)).slice(0, 1);
    }

    if (quest.highlightTargets) {
        units = units.concat(Map2d.currentMap.listAvailableUnits(quest.highlightTargets));
    } else if (quest.highlightTargets === false) {
        units = [];
    }

    const savedControls = cleverapps.focusManager.controls.slice();

    const actions = [
        (f) => {
            Map2dLocation.currentLocation.unitStories.showUnitStory(f, quest.getDialogue(), {
                unit: units,
                cancelZoomOut: quest.cancelZoomOut
            });
        },

        (f) => {
            quest.setFresh(false);
            this.save();

            const controls = quest.lockMapDuringStartQuest ? cleverapps.substract(savedControls, ["map2d"]) : savedControls;
            cleverapps.focusManager.showControlsWhileFocused(controls);
            cleverapps.focusManager.setEventNodes([Map2d.currentMap.scroller.onDiscoverScrollView()]);

            cleverapps.timeouts.setTimeout(f, 600);
        },

        (f) => {
            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);

            quests.forEach((quest, index) => {
                cleverapps.timeouts.setTimeout(() => {
                    quest.setFresh(false);
                    this.save();

                    cleverapps.effects.fire(cleverapps.skins.getSlot("startQuestsEffect") || "quests.start");

                    const questsGroupIcon = cleverapps.sideBar.findIconByClassName(QuestsGroupIcon);
                    if (questsGroupIcon && questsGroupIcon.available) {
                        if (!questsGroupIcon.onGetIconViewListener(quest)) {
                            this.trigger("questAdded", quest);
                        }

                        const addedIcon = questsGroupIcon.onGetIconViewListener(quest);
                        if (addedIcon) {
                            questsGroupIcon.onGetView().scrollToItem(addedIcon, () => {
                                questsGroupIcon.showInfo(addedIcon.quest, {
                                    iconView: addedIcon,
                                    duration: 0.5,
                                    delay: 0.2
                                });
                            });
                        }
                    } else {
                        const questsIcon = cleverapps.sideBar.findIconByClassName(QuestsIcon);
                        if (questsIcon && questsIcon.available) {
                            this.trigger("questAdded", quest);
                            questsIcon.showInfo(quest, { duration: 0.5, delay: 0.2 });
                        }
                    }
                }, index * (QuestsWindow.IsAvailable() ? 2400 : 1600));
            });
            cleverapps.timeouts.setTimeout(f, quests.length * 2000);
        },

        (f) => {
            if (cleverapps.meta.getSelectedLocation().locationConfig.usePathIndicator && findOnStart) {
                const questForPathShow = quests.find((q) => q.findOnStart);
                if (questForPathShow) {
                    questForPathShow.find();
                    cleverapps.timeouts.setTimeout(f, 3000);
                } else {
                    quest.find(quest.silentFind !== false);
                    f();
                }
            } else {
                f();
            }
        },

        (f) => {
            this.trigger("afterQuestAdded");
            quest.showTutorial(f);
        }
    ];

    cleverapps.focusManager.display({
        focus: "StartQuest",
        action: (f) => new ActionPlayer(actions).play(f)
    });
};

Quests.prototype.onMapEvent = function (type, options) {
    this.quests.forEach((quest) => {
        if (quest.isApplicable(type, options)) {
            quest.addProgress(options && options.amount || 1, options);
        }
    }, this);

    this.finishHeroChestQuests();

    if (type === Map2d.OPENFOG) {
        this.create(options);
    }

    if (type === Map2d.RECIPE_NEW && this.quests.some((quest) => quest.recipeCode !== options.source.recipe.code)) {
        this.create(options.source);
    }
};

Quests.prototype.isRepeatedQuestsAvailable = function () {
    return cleverapps.meta.getSelectedLocation().locationConfig.isMain && cleverapps.user.checkAvailable(cleverapps.config.availables.REPEATED_QUESTS)
        && this.lastFinished + Quests.START_REPEATED_TIMEOUT < Date.now();
};

Quests.prototype.runRepeatedQuests = function () {
    if (!this.isRepeatedQuestsAvailable() || this.quests.length >= 5) {
        return;
    }

    const activeIds = this.quests.map(Quest.GetId);
    const activeRepeatedIds = cleverapps.intersect(Object.keys(RepeatedQuests), activeIds);

    const toStart = Quests.CONCURRENT_REPEATED_QUESTS - activeRepeatedIds.length;
    if (toStart <= 0) {
        return;
    }

    const pseudo = PseudoRandom.GET("quests");
    pseudo.seed(Date.now());

    let candidates = [];
    for (const key in RepeatedQuests) {
        if (RepeatedQuests[key].dynamic && RepeatedQuests[key].dynamic.filter) {
            if (RepeatedQuests[key].dynamic.filter()) {
                candidates.push(key);
            }
            continue;
        }

        candidates.push(key);
    }
    candidates = pseudo.shuffle(candidates);
    candidates = cleverapps.substract(candidates, activeRepeatedIds);

    const configs = [];
    for (let i = 0; i < candidates.length && configs.length < toStart; i++) {
        const config = RepeatedQuests[candidates[i]];

        if (!config.dynamic || config.dynamic.getUnit && config.dynamic.getUnit()) {
            configs.push(config);
        }
    }

    if (configs.length > 0) {
        this.startQuests(configs);
    }
};

Quests.prototype.destructor = function () {
    runCleaners(this);
};

Quests.FakeQuests = {
    isAllDone: false,
    isRepeatedQuestsAvailable: function () {},
    finishHeroChestQuests: function () {},
    finishQuestsByCode: function () {},
    finish: function () {},
    processFresh: function () {},
    destructor: function () {},
    load: function () {},
    startQuests: function () {},
    create: function () {},
    save: function () {}
};

Quests.tryFixUnitStage = function (unit) {
    if (!unit || !unit.code || unit.stage === undefined) {
        return true;
    }

    const family = Families[unit.code];
    if (!family) {
        return false;
    }

    if (family.units[unit.stage]) {
        return true;
    }

    const deleted = Families.DELETED_STAGES && Families.DELETED_STAGES[unit.code];
    if (deleted) {
        const original = unit.stage;
        for (let i = 0; i < deleted.length && deleted[i] <= original; i++) {
            unit.stage -= 1;
        }
    }

    return Boolean(family.units[unit.stage]);
};

Quests.CONCURRENT_REPEATED_QUESTS = 2;
Quests.START_REPEATED_TIMEOUT = cleverapps.parseInterval("1 minute");

UniversalSlot.registerTable("quests", {
    getInfo: (slot) => slot.load("quests"),
    updateInfo: (slot, serverData) => slot.save("quests", serverData, true)
});
